module.exports = __webpack_public_path__ + "static/media/echtzeit~bvyddfPe.280c85fc.svg";